module.exports = __webpack_public_path__ + "src/img/error.7eb2c16b.png";